import styled from "@emotion/styled";
import {
  Card as MuiCard, CardContent as MuiCardContent, FormControlLabel as MuiFormControlLabel, Tab as MuiTab,
  DialogTitle as MuiDialogTitle, ImageListItem as MuiImageListItem, Checkbox as MuiCheckbox, Dialog as MuiDialog,
  InputLabel as MuiInputLabel, Drawer as MuiDrawer, IconButton as MuiIconButton, IconButton, Tabs as MuiTabs, ImageList as MuiImageList
} from '@mui/material';
import { Navbar as RbNavbar } from 'reactstrap';

const shouldForwardProp = (prop: string) => prop !== "checked" && prop !== "selecting";

export const TwoPartDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-evenly;
  gap: 10px;
  width: 100%;
  height: 100vh;
  padding: 12px;
`

export const Part1Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
  flex: 1;
  padding: 72px;
`

export const Part2Div = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0px;
  flex: 1;
  background-color: #F4F4F4;
  height: 100%;
  border-radius: 16px;
  padding: 24px;
`

export const TextFieldStyleObj = {
  marginTop: '16px',
  position: "absolute",
  bottom: "20px",
  width: "90%",
  maxWidth: "400px"
};

export const MsgIconButton = styled(IconButton)`
  position: absolute;
  right: 33px;
  bottom: 40px;
  background-color: #f5d1f5;
  border: none;
  padding: 8px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: purple;
`

export const WhiteSpinnerSpan = styled.span`
  position: relative;
  top: 3px;
  text-align: center;
`

export const GoogleIconImg = styled.img`
  height: 20px;
  min-width: 20px;
  width: 20px;
  left: 5%;
  position: absolute;
`

export const CenterBox = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 90%;
  max-width: 400px;
  margin: 20px auto;
`

export const LeftBox = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  max-width: 550px;
  margin: 20px auto;
`

export const Heading2 = styled.h2`
  color: #1E1E1E;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  margin: 0px;
`

export const Text = styled.p`
  color: #747775;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0px;
`

export const Claim = styled.p`
  margin: 0px;
  color: #1E1E1E;
  text-align: center;
  font-family: 'TT Commons Pro';
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.15px;
`

export const FormQuestion = styled(Text)`
  font-weight: 500;
  font-size: 16px;
  color: #000;
  margin-top: 24px;
  margin-bottom: 8px;
`

export const UploadText = styled(Text)`
  color: #A20B91;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
`

export const TextGray = styled(Text)`
  color: #757575;
  font-weight: 500;
  letter-spacing: 0.15px;
  align-self: stretch;
`

export const Input = styled.input`
  display: flex;
  height: 56px;
  align-self: stretch;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 12px;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  padding: 20px 4px 20px 16px;
  border: 1px solid #B3B3B3;
`

export const BaseButton = styled.button`
  display: flex;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #A20B91;
  color: #FFF;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  border: none;
`

export const Button = styled(BaseButton)`
  padding: 10px 24px;
`

export const ButtonSecondary = styled(BaseButton)`
  background-color: #E5E5EA;
  color: #A20B91;
`

export const ButtonStretched = styled(BaseButton)`
  align-self: stretch;
`

export const GoogleButton = styled(ButtonStretched)`
  background-color: rgb(255, 255, 255);
  outline: none;
  color: rgba(91,92,90,1.00);
  border: 1px solid rgb(191, 191, 191);
  position: relative;
`

export const LinkBlack = styled.a`
  color: #1F1F1F;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-decoration: none;
  cursor: pointer;
`

export const LinkPurple = styled.a`
  color: #A20B91;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.5px;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: #A20B91;
  }
`

export const LinkHover = styled.a`
  color: #A20B91;
  padding: 10px;
  cursor: pointer;
  border-radius: 50px;
  text-decoration: none;
  background-color: #E5E5EA;

  &:hover {
    color: #A20B91;
    background-color: #D9D9D9 !important;
  }
`

export const LogoImg = styled.img`
  width: 30px;
`

export const LogoNameImg = styled.img`
  width: 100px;
  margin-top: 5px;
  margin-left: 4px;
`

export const AdditionalImg = styled.img`
  width: 23px;
`

export const SkeletonDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 30px;
  margin-top: 32px;
`

export const UploadImg = styled.img`
  width: 35px;
  position: absolute;
  right: 5px;
  bottom: 2px;
  color: #A20B91,
`

export const FilesImg = styled.img`
  width: 95px;
`

export const Navbar = styled(RbNavbar)`
  padding: 24px;
`

export const SendImg = styled.img`
  width: 24px;
`

export const BodyDiv = styled.div`
  position: absolute;
  top: 90px;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 24px;
  overflow-y: scroll;
`

export const Header = styled.p`
  color: #1E1E1E;
  font-family: "Open Sans", sans-serif;
  font-size: 22px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  margin-bottom: 8px;
  margin-top: 0px;
`

export const SubHeader = styled.p`
  color: #1D1B20;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0px;
`

export const HiddenInput = styled.input`
  display: none;
`

export const ButtonLabel = styled.label`
  display: flex;
  height: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 100px;
  background: #A20B91;
  color: #FFF;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.1px;
  border: none;
  padding: 10px 24px;
  cursor: pointer;
`

export const PhotoCards = styled.img`
  width: 250px;
  margin-top: 150px;
`

export const Card = styled(MuiCard, { shouldForwardProp })<{ checked: boolean; selecting: boolean }>`
  width: 330px;
  border-radius: 16px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  border: 3px solid #FFF;
  box-shadow: 0px 1px 4px 0px #0C0C0D1A, 0px 1px 4px 0px #0C0C0D0D;

  &:hover {
    transform: scale(1.02);
    transition: filter 0.3s ease-in-out;
  }

  &:hover img {
    filter: brightness(0.7);
  }

  ${({ selecting }) => selecting && `
    &:hover .checkbox, .checkbox:checked {
      opacity: 1;
    }
  `}

  ${({ checked }) => checked && `
    border: 3px solid #A20B91;
  `}
`

export const CardContent = styled(MuiCardContent)`
  padding: 12px 9px;

  &:last-child {
    padding-bottom: 9px;
  }
`

export const StepIndex = styled.div`
  width: 20px;
  height: 20px;
  background-color: #A20B91;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 12px;
  font-weight: 500;
`

export const CardsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
`

export const Tab = styled(MuiTab)`
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  margin: 0px;
  text-transform: none !important;

  &.Mui-selected {
    font-weight: 600;
    color: #000;
  }
`

export const Tabs = styled(MuiTabs)`
  & .MuiTabs-indicator {
    background-color: #A20B91;
    height: 3px;
    border-radius: 4px 4px 0 0;
  }
`

export const DialogTitle = styled(MuiDialogTitle)`
  padding: 0px !important;
  margin-bottom: 24px;
`

export const UploadDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  padding: 40px;
  border: 1px solid #79747E;
  margin-top: 32px;
  margin-bottom: 12px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  gap: 28px;
  background: #FFF;
  border-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D9D9D9' stroke-width='2' stroke-dasharray='10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e") 1;

  &:hover {
    border-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23D9D9D9' stroke-width='2' stroke-dasharray='10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e") 1;
    background-color: rgb(250, 250, 250);
  }
`

export const CollectionImg = styled.img`
  border-top-right-radius: 12px;
  border-top-left-radius: 12px;
  display: block;
  width: 100%;
  cursor: pointer;
`

export const ImageDiv = styled(MuiImageListItem, { shouldForwardProp })<{ checked: boolean; selecting: boolean }>`
  position: relative;
  border-radius: 16px;
  border: 3px solid #FFF;
  box-shadow: 0px 1px 4px 0px #0C0C0D1A, 0px 1px 4px 0px #0C0C0D0D;

  &:hover img {
    filter: brightness(0.7);
    transition: filter 0.3s ease-in-out;
  }

  ${({ selecting }) => selecting === true && `
    &:hover .checkbox, .checkbox:checked {
      opacity: 1;
    }
  `}

  ${({ checked }) => checked && `
    border: 3px solid #A20B91;
  `}
`

export const ImageList = styled(MuiImageList)`
  margin-top: 32px;
  overflow-y: visible !important;
  height: auto;
  
  &.MuiImageList-root {
    overflow-y: visible !important;
  }
`;

export const ImgCheckbox = styled(MuiCheckbox)<{ checked: boolean }>`
  position: absolute;
  top: 0px;
  left: 0px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  color: #FFFFFF;
  z-index: 2;

  &.Mui-checked {
    color: #FFFFFF;
  }

  ${({ checked }) => checked === true && `
    opacity: 1;
  `}
`

export const TopRightDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 12px;
  margin-bottom: 32px;
`

export const ButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
`

export const Dialog = styled(MuiDialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    padding: 18,
    borderRadius: 20,
    maxWidth: 500,
    width: '100%',
  },
}));

export const Label = styled(MuiFormControlLabel)`
  color: #625B71;
  margin: 0px;
  display: block;

  & .MuiFormControlLabel-label {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
`

export const Checkbox = styled(MuiCheckbox)`
  padding: 11px;
  color: #A20B91;

  &:hover {
    background-color: transparent;
  }
`

export const InputLabel = styled(MuiInputLabel)({
  '&.Mui-focused': {
    color: '#1D1B20',
  },
});

export const SideBarRight = styled(MuiDrawer)`
  & .MuiDrawer-paper {
    max-width: 350px;
    width: 100%;
  }
`

export const BigImage = styled.img`
  object-fit: contain;
  margin: auto;
  display: block;
  height: 95vh;
  padding: 10px;
`

export const LogoBigImg = styled.img`
  margin-bottom: 24px;
`

export const CureytaBigImg = styled.img`
  margin-bottom: 8px;
`

export const CloseButton = styled(MuiIconButton)`
  position: absolute;
  right: 10px;
  top: 10px;
  background-color: rgba(255, 255, 255, 0.80);
  color: #000000;
  z-index: 1;
  
  &:hover {
    background-color: #000000;
    color: white;
  }
`

type BorderedBoxProps = {
  isChecked?: boolean;
}
export const BorderedBox = styled.div<BorderedBoxProps>`
  border-radius: 16px;
  display: flex;
  flex-direction: row;
  border: 1px solid ${props => props.isChecked ? '#A20B91' : '#D9D9D9'};
  background-color: ${props => props.isChecked ? '#FBF7FF' : '#FFFFFF'};
  box-shadow: ${props => props.isChecked ? '0px 1px 3px rgba(162, 11, 145, 0.1)' : 'none'};
  box-sizing: border-box;
  margin-bottom: 12px;
  padding: 16px;
  width: 100%;
  max-width: 550px;
  justify-content: space-between;
  gap: 12px;
  cursor: pointer;
`

export const FileArea = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 2px dashed #E5E7EB;
  border-radius: 8px;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  max-width: 550px;
  background: #fff;
`

export const BorderedIconBox = styled.div`
  border-radius: 16px;
  padding: 12px;
  border: 1px solid #ccc;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
`

export const MessageBody = styled.div`
  padding: 8px 12px !important;
  color: #050505;
  white-space: normal;
  border-radius: 12px;
  word-break: break-word;
  min-height: fit-content;
  line-height: 18px;
  width: auto;
  max-width: 85%;
  margin-bottom: 10px;
`

export const ErrorText = styled.p`
  color: rgb(255, 90, 84);
  font-size: 15px;
  line-height: 15.8px;
  margin-top: 0px;
`

export const AccountsImg = styled.img`
  height: 48px;
  width: 48px;
  margin-right: 12px;
  border-radius: 100px;
  object-fit: cover;
  background-color: #fff;
  padding: 2px;
  cursor: pointer;
`

export const DropdownDiv = styled.div`
  border-radius: 16px;
  width: 200px;
  background-color: rgba(255,255,255,1.00);
  box-sizing: border-box;
  outline: none;
  border: 1px solid #EBEBEB;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.04em;
  text-align: left;
  color: rgba(30, 28, 36, 0.85);
  padding: 8px;
  position: absolute;
  top: 75px;
  right: 38px;
  z-index: 1;
`

export const ButtonP = styled.p`
  padding: 12px;
  margin: 0px;
  position: relative;
  cursor: pointer;
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 0.04em;
  text-align: left;
  color: #A20B91;

  :hover {
    background-color: rgba(68, 73, 80, 0.15);
    border-radius: 10px;
  }
`

export const PresetsIcon = styled.img`
  width: 24px;
  height: 24px;
`

export const LoadingImg = styled.img`
  width: 179px;
  height: 132px;
  margin-bottom: 24px;
  display: block;
  margin: 0 auto 24px;
`

export const StackDivCol = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StackDivRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 12px;
`;

export const RowDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0px auto;
`

export const ProgressContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
`

export const ProgressBar = styled.div<{ progress: number }>`
  width: 100%;
  height: 4px;
  background: #F4F4F5;
  border-radius: 2px;
  margin: 8px 0;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: ${props => props.progress}%;
    background: #A20B91;
    border-radius: 2px;
    transition: width 0.3s ease;
  }
`

export const EmailInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #A20B91;
  }
`

export const SubmitButton = styled.button`
  background: #A20B91;
  color: white;
  padding: 8px 16px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    background: #8A0979;
  }
`

export const ChatBody = styled.div`
  flex: 1;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 16px;
`

export const MessagesContainer = styled.div`
  position: absolute;
  top: 16px;
  left: 0;
  right: 0;
  bottom: 120px;
  overflow-y: auto;
  padding: 12px;
  display: flex;
  flex-direction: column-reverse;
`

export const ChatInputArea = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid rgba(20, 23, 33, 0.10);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  padding: 12px 12px 12px 17px;
`

export const MessageInput = styled.textarea`
  width: 100%;
  font-size: 16px;
  border: none;
  padding: 0px;
  resize: none;

  &:focus {
    outline: none;
    border-color: #A20B91;
  }
`

export const SendButton = styled.button`
  display: flex;
  width: 48px;
  height: 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 16px;
  background: #F1CEED;
  border: none;
`

export const SuccessBox = styled.div`
  border-radius: 12px;
  display: flex;
  padding: 20px;
  flex-direction: column;
  position: relative;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  margin-top: 32px;
  // border: 1px solid var(--Success-border, #21A915);
  // background: var(--Success-fill, #CBEDC7);
  // box-shadow: 0px 1px 4px 0px rgba(12, 12, 13, 0.1),
  //             0px 1px 4px 0px rgba(12, 12, 13, 0.06);
`;

export const Chatbox = styled.div`
  border: 1px solid #E5E7EB;
  border-radius: 16px;
  padding: 24px;
  height: 500px;
  display: flex;
  flex-direction: column;
`

export const Chatheader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`

export const MessageWrapper = styled.div<{ isUser: boolean }>`
  display: flex;
  justify-content: ${props => props.isUser ? 'flex-end' : 'flex-start'};
  margin-bottom: 8px;
`;

export const MessageBubble = styled.div<{ isUser: boolean }>`
  max-width: 80%;
  padding: 12px 16px;
  border-radius: 16px;
  background-color: ${props => props.isUser ? '#A20B91' : '#F4F4F5'};
  color: ${props => props.isUser ? 'white' : 'inherit'};
  font-size: 14px;
  line-height: 20px;
`;

export const GrayNavContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #F5F5F5;
  padding: 16px 24px;
  border-radius: 100px;
  margin: 16px 0;
  flex-direction: row;
`

export const DividerVert = styled.div`
  height: 32px;
  width: 1px;
  background-color: #D9D9D9;
  margin: 0 8px;
`;

export const ArrowImagesDiv = styled.div`
  position: relative;

  .step-image {
    position: relative;
    z-index: 1;
  }

  .arrow-image {
    position: absolute;
    bottom: 84px;
    right: 115px;
    width: 30px;
    z-index: 2;
  }

  .dashed-line {
    position: absolute;
    bottom: -146px;
    right: 89px;
    z-index: 1;
  }
`
